enum AiFeatureType {
  EMAIL_GENERATE = "email-generate",
}

export default AiFeatureType;
